export const CREATE_MISCELLANEOUS_RECORD = "CREATE_MISCELLANEOUS_RECORD";
export const FETCH_MISCELLANEOUS_RECORDS = "FETCH_MISCELLANEOUS_RECORDS";
export const FETCH_MISCELLANEOUS_RECORD = "FETCH_MISCELLANEOUS_RECORD";
export const EDIT_MISCELLANEOUS_RECORD = "EDIT_MISCELLANEOUS_RECORD";
export const DELETE_MISCELLANEOUS_RECORD = "DELETE_MISCELLANEOUS_RECORD";
